/**
 * Mapa de la sala de ventas, en el pie.
 *
 * Todo el recuadro es un enlace que abre la ficha de la ferretería en Google
 * Maps —con sus horarios, fotos y reseñas— en otra pestaña. El mapa de adentro
 * es la ilustración: va `inert` y sin recibir el puntero, para que el clic y el
 * tabulador lleguen siempre al enlace y nadie quede atrapado haciendo zoom
 * dentro de un iframe que no lleva a ninguna parte.
 *
 * Se carga diferido porque el pie está en todas las páginas y es un recurso de
 * un tercero: no puede competir por el ancho de banda con la foto del producto.
 *
 * Las dos URL salen del mismo CID (`SITIO.mapaCid`), así que el mapa y el
 * enlace no pueden terminar apuntando a lugares distintos.
 */
import { SITIO } from '../../configuracion/sitio';
import { Icono } from '../comunes/Icono';

/** Ficha del negocio en Google Maps, para abrir en una pestaña nueva. */
const ENLACE_MAPS = `https://www.google.com/maps?cid=${SITIO.mapaCid}`;

/** El mismo lugar, embebido. No necesita clave de API, pero solo funciona dentro de un iframe. */
const MAPA_EMBEBIDO = `${ENLACE_MAPS}&output=embed`;

export function MapaTienda() {
  const direccion = `${SITIO.direccion.calle}, ${SITIO.direccion.comuna}`;

  return (
    <div className="pie-mapa">
      <iframe
        className="pie-mapa-lienzo"
        title={`Mapa de ${SITIO.nombreLargo} en ${direccion}`}
        src={MAPA_EMBEBIDO}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        tabIndex={-1}
        inert
      />

      <a
        className="pie-mapa-enlace"
        href={ENLACE_MAPS}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="pie-mapa-accion">
          <Icono nombre="tienda" />
          Cómo llegar
        </span>
        <span className="solo-lectores">
          Ver {SITIO.nombreLargo}, {direccion}, en Google Maps. Se abre en una pestaña nueva.
        </span>
      </a>
    </div>
  );
}
